import { z } from 'zod';

/**
 * Current privacy policy version (apps/tma/public/privacy.html shows the same string).
 * Bump it whenever the policy text changes — every user re-accepts on next open.
 * Deploy the API no later than the TMA when bumping it: an older API + newer bundle loops on POLICY_OUTDATED reloads.
 */
export const PD_POLICY_VERSION = '2026-09-11';

/**
 * POST /profile/consent. `contact` is the raw signed string from
 * Telegram.WebApp.requestContact; omitted when the user already has a phone
 * and only re-accepts a new policy version.
 */
export const consentAcceptSchema = z
  .object({
    policyVersion: z.string().min(1).max(32),
    contact: z.string().min(1).max(4096).optional(),
  })
  .strict();

export type ConsentAcceptInput = z.infer<typeof consentAcceptSchema>;
